// Deterministic external research links — NO AI, NO scraping, NO server calls.
export function buildPropertyResearchLinks(normalizedAddress) {
  const q = encodeURIComponent(normalizedAddress || "");
  const dash = encodeURIComponent((normalizedAddress || "").replace(/,/g, "").replace(/\s+/g, "-"));
  return {
    zillow: `https://www.zillow.com/homes/${dash}_rb/`,
    redfin: `https://www.redfin.com/search#query=${q}`,
    realtor: `https://www.realtor.com/realestateandhomes-search?searchQuery=${q}`,
    homes: `https://www.homes.com/search/?query=${q}`,
    trulia: `https://www.trulia.com/search/?query=${q}`,
    google_maps: `https://www.google.com/maps/search/?api=1&query=${q}`,
    aerial: `https://www.bing.com/maps?where1=${q}&style=h`,
  };
}

export const RESEARCH_SITES = [
  ["zillow", "Zillow"], ["redfin", "Redfin"], ["realtor", "Realtor.com"],
  ["homes", "Homes.com"], ["trulia", "Trulia"], ["google_maps", "Google Maps"],
];

export const VISUALS_SITES = [
  ["google_maps", "Map"], ["aerial", "Aerial / Satellite"], ["zillow", "Zillow"], ["redfin", "Redfin"],
  ["realtor", "Realtor.com"], ["homes", "Homes.com"], ["trulia", "Trulia"],
];

export function normalizeAddressClient(p) {
  return [p?.property_address, p?.city, [p?.state, p?.zip_code].filter(Boolean).join(" ")].filter(Boolean).join(", ");
}
